import { PasswordRecoveryRequestSchema, PasswordRecoveryRequestedSchema } from "@vekha/contracts";
import { DealBotDeliverySchema, type DealBotDelivery } from "@vekha/contracts";
import { SandboxAgentSchema, type SandboxAgent } from "@vekha/contracts";
import { ReportViewSchema, type ReportView } from "@vekha/contracts";
import { SandboxDealSchema, SandboxWorkflowSchema, SandboxCreateSchema, SandboxTurnInputSchema, type SandboxDeal, type SandboxWorkflow } from "@vekha/contracts";
import { SemanticStagingStatusSchema, type SemanticStagingStatus, SemanticComparisonSchema, SemanticComparisonStartSchema, SemanticReviewSchema } from "@vekha/contracts";
import {
  AllowlistMutationResultSchema,
  AllowlistMutationSchema,
  AppBootstrapSchema,
  AuthenticationStateSchema,
  ConversationControlMutationSchema,
  ConversationControlResultSchema,
  ConversationKindMutationSchema,
  ConversationKindResultSchema,
  ConversationPolicyRegenerationResultSchema,
  ConversationPolicyRegenerationSchema,
  ConversationRecoveryResultSchema,
  FirstContactRetryMutationSchema,
  FirstContactRetryResultSchema,
  ConversationRecoverySchema,
  OwnerLeadReturnMutationSchema,
  OwnerLeadReturnOptionsSchema,
  OwnerLeadReturnResultSchema,
  type OwnerLeadReturnMutation,
  type OwnerLeadReturnOptions,
  type OwnerLeadReturnResult,
  CompanyMediaAssetArchiveMutationSchema,
  CompanyMediaAssetArchiveResultSchema,
  CompanyMediaAssetMutationResultSchema,
  CompanyMediaAssetMutationSchema,
  CrmDealDetailSchema,
  CrmDealLinkResolutionMutationSchema,
  CrmDealLinkResolutionResultSchema,
  CrmDealListQuerySchema,
  CrmDealListSchema,
  YanaDayQuerySchema,
  YanaDaySchema,
  CrmDealEventsSchema,
  type CrmDealEvents,
  type YanaDay,
  type YanaDayQuery,
  DialogLiveChangeSchema,
  type DialogLiveChange,
  CrmDealNoReplyMutationSchema,
  CrmDealNoReplyResultSchema,
  CrmDealReconciliationMutationSchema,
  CrmDealReconciliationResultSchema,
  CrmDealTimelineQuerySchema,
  CrmDealTimelineSchema,
  ContactChannelListSchema,
  DealQualificationSchema,
  type DealQualification,
  DeliveryStateSchema,
  DraftDecisionResultSchema,
  DraftDecisionSchema,
  DraftEditSchema,
  EmployeeVersionPublicationMutationSchema,
  EmployeeVersionPublicationResultSchema,
  HistoricalCaseImportMutationSchema,
  HistoricalCaseImportResultSchema,
  HistoricalCaseSummariesSchema,
  HistoricalReplayRunSchema,
  HistoricalReplayRunsSchema,
  HistoricalReplayScheduleSnapshotRequestSchema,
  HistoricalReplayScheduleSnapshotResultSchema,
  HistoricalReplayStartMutationSchema,
  HistoricalReplayStartResultSchema,
  GoogleSheetsScheduleAnalysisSchema,
  GipnoActionLogQuerySchema,
  GipnoActionLogSchema,
  EmployeeMutationSchema,
  KnowledgeSourceDetailSchema,
  KnowledgeSourceMutationResultSchema,
  KnowledgeSourceMutationSchema,
  LoginSchema,
  OwnerEscalationAdviceMutationSchema,
  OwnerEscalationAdviceResultSchema,
  PostBookingPreviewReviewMutationSchema,
  PostBookingPreviewReviewResultSchema,
  PreviewPilotScopeMutationResultSchema,
  PreviewPilotScopeMutationSchema,
  PreviewProcessingGrantMutationResultSchema,
  PreviewProcessingGrantMutationSchema,
  PrivilegedConfirmationSchema,
  RestoreReconciliationMutationSchema,
  RestoreSafetyStateSchema,
  ScenarioMutationSchema,
  ScenarioActivationMutationSchema,
  ScenarioActivationResultSchema,
  ScenarioDeliveryWindowMutationSchema,
  ScenarioDeliveryWindowResultSchema,
  ScenarioOperatingModeMutationSchema,
  ScenarioOperatingModeResultSchema,
  ScenarioResponsibleScopeMutationSchema,
  ScenarioResponsibleScopeResultSchema,
  ScenarioSimulationMutationResultSchema,
  ScenarioSimulationSessionSchema,
  ScenarioSimulationSessionsSchema,
  ScenarioSimulationSessionStartMutationSchema,
  ScenarioSimulationTurnMutationSchema,
  ScheduleBindingActivationMutationSchema,
  ScheduleBindingActivationResultSchema,
  ScheduleBindingDraftMutationSchema,
  ScheduleBindingDraftResultSchema,
  ScheduleBindingPublicationMutationSchema,
  ScheduleBindingPublicationResultSchema,
  ScenarioWorkflowPublicationMutationSchema,
  ScenarioWorkflowPublicationResultSchema,
  SessionStateSchema,
  SetupCompleteSchema,
  SetupStatusSchema,
  TeamAccessAcceptResultSchema,
  TeamAccessSnapshotSchema,
  TeamInvitationAcceptSchema,
  TeamInvitationCreateSchema,
  TeamInvitationRevokeSchema,
  TeamMemberDeactivateSchema,
  TeamMutationResultSchema,
  TeamOneTimeGrantSchema,
  TeamReadinessSchema,
  TeamRosterInviteSchema,
  type TeamReadiness,
  type TeamRosterInvite,
  TeamPasswordResetAcceptSchema,
  TeamPasswordResetCreateSchema,
  TeamRoleChangeSchema,
  TeamRestoreReprovisionCreateSchema,
  WorkspaceSnapshotSchema,
  WorkflowPreviewPilotMutationSchema,
  WorkflowPreviewPilotResultSchema,
  WorkflowScenarioCreateMutationSchema,
  WorkflowScenarioCreateResultSchema,
  type AllowlistMutation,
  type AllowlistMutationResult,
  type AppBootstrap,
  type AuthenticationState,
  type ConversationControlMutation,
  type ConversationControlResult,
  type ConversationKindMutation,
  type ConversationKindResult,
  type ConversationPolicyRegeneration,
  type ConversationPolicyRegenerationResult,
  type ConversationRecovery,
  type ConversationRecoveryResult,
  type FirstContactRetryMutation,
  type FirstContactRetryResult,
  type CompanyMediaAssetArchiveMutation,
  type CompanyMediaAssetMutation,
  type CompanyMediaAssetMutationResult,
  type CrmDealDetail,
  type CrmDealLinkResolutionMutation,
  type CrmDealLinkResolutionResult,
  type CrmDealList,
  type CrmDealListQuery,
  type CrmDealNoReplyMutation,
  type CrmDealNoReplyResult,
  type CrmDealReconciliationMutation,
  type CrmDealReconciliationResult,
  type CrmDealTimeline,
  type ContactChannelList,
  type CrmDealTimelineQuery,
  type DeliveryState,
  type DeliveryStateMutation,
  type DraftDecision,
  type DraftDecisionResult,
  type DraftEdit,
  type EmployeeVersionPublicationMutation,
  type EmployeeVersionPublicationResult,
  type HistoricalCaseImportMutation,
  type HistoricalCaseImportResult,
  type HistoricalCaseSummary,
  type HistoricalReplayRun,
  type HistoricalReplayScheduleSnapshotRequest,
  type HistoricalReplayScheduleSnapshotResult,
  type HistoricalReplayStartMutation,
  type HistoricalReplayStartResult,
  type GoogleSheetsScheduleAnalysis,
  type GipnoActionLog,
  type GipnoActionLogQuery,
  type EmployeeMutation,
  type KnowledgeSourceDetail,
  type KnowledgeSourceMutation,
  type KnowledgeSourceMutationResult,
  type Login,
  type OwnerEscalationAdviceMutation,
  type OwnerEscalationAdviceResult,
  type PostBookingPreviewReviewMutation,
  type PreviewPilotScopeMutation,
  type PreviewPilotScopeMutationResult,
  type PreviewProcessingGrantMutation,
  type PreviewProcessingGrantMutationResult,
  type RestoreReconciliationMutation,
  type RestoreSafetyState,
  type ScenarioMutation,
  type ScenarioActivationMutation,
  type ScenarioActivationResult,
  type ScenarioDeliveryWindowMutation,
  type ScenarioDeliveryWindowResult,
  type ScenarioOperatingModeMutation,
  type ScenarioOperatingModeResult,
  type ScenarioResponsibleScopeMutation,
  type ScenarioResponsibleScopeResult,
  type ScenarioSimulationMutationResult,
  type ScenarioSimulationSession,
  type ScenarioSimulationSessionStartMutation,
  type ScenarioSimulationTurnMutation,
  type ScheduleBindingActivationMutation,
  type ScheduleBindingActivationResult,
  type ScheduleBindingDraftMutation,
  type ScheduleBindingDraftResult,
  type ScheduleBindingPublicationMutation,
  type ScheduleBindingPublicationResult,
  type ScenarioWorkflowPublicationMutation,
  type ScenarioWorkflowPublicationResult,
  type SessionState,
  type SetupComplete,
  type SetupStatus,
  type TeamAccessAcceptResult,
  type TeamAccessSnapshot,
  type TeamInvitationAccept,
  type TeamInvitationCreate,
  type TeamInvitationRevoke,
  type TeamMemberDeactivate,
  type TeamMutationResult,
  type TeamOneTimeGrant,
  type TeamPasswordResetAccept,
  type TeamPasswordResetCreate,
  type TeamRoleChange,
  type TeamRestoreReprovisionCreate,
  type WorkspaceSnapshot,
  type WorkflowPreviewPilotMutation,
  type WorkflowPreviewPilotResult,
  type WorkflowScenarioCreateMutation,
  type WorkflowScenarioCreateResult,
} from "@vekha/contracts";
import type {
  AmoCrmReverificationMutation,
  AmoCrmReverificationResult,
  AmoOAuthStartMutation,
  AmoOAuthStartResult,
  EmployeeMutationResult,
  GoogleSheetsIntegrationMutation,
  GoogleSheetsIntegrationResult,
  GoogleSheetsOAuthStartMutation,
  GoogleSheetsOAuthStartResult,
  GoogleSheetsSpreadsheetMutation,
  GoogleSheetsSpreadsheetResult,
  ScenarioMutationResult,
  WazzupIntegrationMutation,
  WazzupIntegrationResult,
} from "./models";

const REQUEST_TIMEOUT_MS = 8_000;
export const WORKSPACE_RECOVERY_TIMEOUT_MS = 20_000;
// Heavy workspace projections can exceed the generic 8s request budget.
const WORKSPACE_READ_TIMEOUT_MS = WORKSPACE_RECOVERY_TIMEOUT_MS;
// Wazzup may spend up to 30 seconds validating a newly configured webhook.
// Keep the browser request alive beyond the provider's bounded callback window;
// the backend still owns the authoritative setup state if the client disconnects.
const INTEGRATION_TIMEOUT_MS = 50_000;

type ErrorBody = {
  error?: {
    code?: string;
    message?: string;
    requestId?: string;
  };
  message?: string;
};

type DraftEditResult = Readonly<{ draftRevisionId: string }>;

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

export class ApiRequestError extends Error {
  readonly status: number | null;
  readonly code: string | null;
  readonly requestId: string | null;

  constructor(
    message: string,
    options: { status?: number; code?: string; requestId?: string } = {},
  ) {
    super(message);
    this.name = "ApiRequestError";
    this.status = options.status ?? null;
    this.code = options.code ?? null;
    this.requestId = options.requestId ?? null;
  }
}

function withTimeout(timeoutMs = REQUEST_TIMEOUT_MS): { signal: AbortSignal; dispose: () => void } {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
  return {
    signal: controller.signal,
    dispose: () => window.clearTimeout(timeout),
  };
}

type PendingWorkspaceRead = {
  promise: Promise<WorkspaceSnapshot>;
  timedOut: boolean;
  retentionTimer: number | null;
};

const pendingWorkspaceReads = new Map<string, PendingWorkspaceRead>();

export function discardPendingWorkspaceReads(): void {
  for (const read of pendingWorkspaceReads.values()) {
    if (read.retentionTimer !== null) window.clearTimeout(read.retentionTimer);
  }
  pendingWorkspaceReads.clear();
}

function withSoftTimeout<T>(
  read: Promise<T>,
  timeoutMs: number,
  timeoutError: () => ApiRequestError,
  onTimeout?: () => void,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      onTimeout?.();
      reject(timeoutError());
    }, timeoutMs);
    void read.then(
      (value) => {
        window.clearTimeout(timeout);
        resolve(value);
      },
      (error: unknown) => {
        window.clearTimeout(timeout);
        reject(error);
      },
    );
  });
}

async function parseError(response: Response): Promise<ApiRequestError> {
  let body: ErrorBody | null = null;
  try {
    body = (await response.json()) as ErrorBody;
  } catch {
    body = null;
  }
  const error = body?.error;
  return new ApiRequestError(
    error?.message ?? body?.message ?? "Сервер не смог выполнить запрос.",
    {
      status: response.status,
      ...(error?.code ? { code: error.code } : {}),
      ...(error?.requestId ? { requestId: error.requestId } : {}),
    },
  );
}

function mutationHeaders(csrfToken: string | null): HeadersInit {
  if (!csrfToken) {
    throw new ApiRequestError(
      "Защитный токен сессии недоступен. Обновите страницу и повторите действие.",
      { code: "CSRF_TOKEN_UNAVAILABLE" },
    );
  }
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-csrf-token": csrfToken,
  };
}

async function authenticatedJsonMutation<T>(input: {
  path: string;
  method: "POST" | "PUT";
  csrfToken: string | null;
  body: unknown;
  parse: (payload: unknown) => T;
  timeoutMs?: number;
}): Promise<T> {
  const timer = withTimeout(input.timeoutMs);
  try {
    const response = await fetch(input.path, {
      method: input.method,
      credentials: "include",
      headers: mutationHeaders(input.csrfToken),
      body: JSON.stringify(input.body),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return input.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(
        "Сервер не подтвердил действие вовремя. Проверьте актуальное состояние перед повтором.",
        { code: "REQUEST_TIMEOUT" },
      );
    }
    throw new ApiRequestError(
      "Не удалось получить подтверждение сервера. Проверьте актуальное состояние перед повтором.",
      { code: "REQUEST_FAILED" },
    );
  } finally {
    timer.dispose();
  }
}

async function publicJsonMutation<T>(input: {
  path: string;
  body: unknown;
  parse: (payload: unknown) => T;
}): Promise<T> {
  const timer = withTimeout();
  try {
    const response = await fetch(input.path, {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(input.body),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return input.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(
        "Сервер не подтвердил одноразовый код вовремя. Проверьте состояние перед повтором.",
        { code: "REQUEST_TIMEOUT" },
      );
    }
    throw new ApiRequestError(
      "Не удалось получить подтверждение сервера. Доступ не изменён.",
      { code: "REQUEST_FAILED" },
    );
  } finally {
    timer.dispose();
  }
}

async function authenticatedJsonQuery<T>(input: {
  path: string;
  parse: (payload: unknown) => T;
  timeoutMessage: string;
  timeoutCode: string;
  failureMessage: string;
  failureCode: string;
}): Promise<T> {
  const timer = withTimeout();
  try {
    const response = await fetch(input.path, {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return input.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(input.timeoutMessage, { code: input.timeoutCode });
    }
    throw new ApiRequestError(input.failureMessage, { code: input.failureCode });
  } finally {
    timer.dispose();
  }
}

function parseDraftEditResult(payload: unknown): DraftEditResult {
  if (!payload || typeof payload !== "object") {
    throw new ApiRequestError("Сервер вернул неполный результат сохранения черновика.");
  }
  const draftRevisionId = (payload as Record<string, unknown>).draftRevisionId;
  if (typeof draftRevisionId !== "string" || !UUID_PATTERN.test(draftRevisionId)) {
    throw new ApiRequestError("Сервер вернул некорректную версию сохранённого черновика.");
  }
  return { draftRevisionId };
}

function payloadRecord(payload: unknown, errorMessage: string): Record<string, unknown> {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new ApiRequestError(errorMessage);
  }
  return payload as Record<string, unknown>;
}

function requiredUuid(
  payload: Record<string, unknown>,
  key: string,
  errorMessage: string,
): string {
  const value = payload[key];
  if (typeof value !== "string" || !UUID_PATTERN.test(value)) {
    throw new ApiRequestError(errorMessage);
  }
  return value;
}

function safeAbsoluteUrl(value: unknown, errorMessage: string): string {
  if (typeof value !== "string" || value.length > 8_192) {
    throw new ApiRequestError(errorMessage);
  }
  let parsed: URL;
  try {
    parsed = new URL(value);
  } catch {
    throw new ApiRequestError(errorMessage);
  }
  const localHttp = parsed.protocol === "http:"
    && ["127.0.0.1", "localhost", "::1"].includes(parsed.hostname);
  if (parsed.protocol !== "https:" && !localHttp) {
    throw new ApiRequestError(errorMessage);
  }
  return parsed.toString();
}

function parseWazzupIntegrationResult(payload: unknown): WazzupIntegrationResult {
  const record = payloadRecord(payload, "Сервер не подтвердил подключение Wazzup.");
  const channelCount = record.channelCount;
  const activeChannelCount = record.activeChannelCount;
  if (
    record.status !== "ready"
    || typeof channelCount !== "number"
    || !Number.isInteger(channelCount)
    || channelCount < 0
    || typeof activeChannelCount !== "number"
    || !Number.isInteger(activeChannelCount)
    || activeChannelCount < 0
    || activeChannelCount > channelCount
  ) {
    throw new ApiRequestError("Сервер вернул несовместимый результат проверки Wazzup.");
  }
  if (record.webhookConfigured !== true) {
    throw new ApiRequestError("Wazzup не подтвердил адрес для входящих сообщений.");
  }
  return { status: "ready", channelCount, activeChannelCount, webhookConfigured: true };
}

function parseGoogleSheetsIntegrationResult(
  payload: unknown,
): GoogleSheetsIntegrationResult {
  const record = payloadRecord(
    payload,
    "Сервер не подтвердил подключение Google Таблиц.",
  );
  if (
    record.status !== "ready"
    || typeof record.spreadsheetTitle !== "string"
    || record.spreadsheetTitle.trim().length === 0
    || typeof record.serviceAccountEmail !== "string"
    || !record.serviceAccountEmail.includes("@")
  ) {
    throw new ApiRequestError(
      "Сервер вернул несовместимый результат проверки Google Таблиц.",
    );
  }
  return {
    status: "ready",
    spreadsheetTitle: record.spreadsheetTitle,
    serviceAccountEmail: record.serviceAccountEmail,
  };
}

function parseGoogleSheetsOAuthStartResult(
  payload: unknown,
): GoogleSheetsOAuthStartResult {
  const record = payloadRecord(
    payload,
    "Сервер не подтвердил начало подключения Google.",
  );
  const authorizationUrl = safeAbsoluteUrl(
    record.authorizationUrl,
    "Сервер вернул некорректный адрес авторизации Google.",
  );
  const authorization = new URL(authorizationUrl);
  if (
    authorization.protocol !== "https:"
    || authorization.hostname !== "accounts.google.com"
    || authorization.pathname !== "/o/oauth2/v2/auth"
  ) {
    throw new ApiRequestError("Сервер вернул неподдерживаемый адрес авторизации Google.");
  }
  const callbackUrl = safeAbsoluteUrl(
    record.callbackUrl,
    "Сервер вернул некорректный callback Google.",
  );
  const callback = new URL(callbackUrl);
  if (
    typeof window !== "undefined"
    && callback.origin !== window.location.origin
  ) {
    throw new ApiRequestError("Callback Google ведёт за пределы VEHA.");
  }
  if (callback.pathname !== "/api/integrations/google-sheets/oauth/callback") {
    throw new ApiRequestError("Сервер вернул неподдерживаемый callback Google.");
  }
  if (typeof record.expiresAt !== "string" || Number.isNaN(Date.parse(record.expiresAt))) {
    throw new ApiRequestError("Сервер не указал срок подключения Google.");
  }
  return { authorizationUrl, callbackUrl, expiresAt: record.expiresAt };
}

function parseGoogleSheetsSpreadsheetResult(
  payload: unknown,
): GoogleSheetsSpreadsheetResult {
  const record = payloadRecord(payload, "Сервер не подтвердил таблицу Google.");
  if (
    record.status !== "ready"
    || typeof record.spreadsheetTitle !== "string"
    || record.spreadsheetTitle.trim().length === 0
  ) {
    throw new ApiRequestError("Сервер вернул несовместимый результат проверки таблицы.");
  }
  return { status: "ready", spreadsheetTitle: record.spreadsheetTitle };
}

function parseAmoOAuthStartResult(payload: unknown): AmoOAuthStartResult {
  const record = payloadRecord(payload, "Сервер не подтвердил начало подключения amoCRM.");
  const authorizationUrl = safeAbsoluteUrl(
    record.authorizationUrl,
    "Сервер вернул некорректный адрес авторизации amoCRM.",
  );
  const authorization = new URL(authorizationUrl);
  if (authorization.hostname !== "www.amocrm.ru" || authorization.pathname !== "/oauth") {
    throw new ApiRequestError("Сервер вернул неожиданный адрес авторизации amoCRM.");
  }
  const callbackUrl = safeAbsoluteUrl(
    record.callbackUrl,
    "Сервер вернул некорректный обратный адрес amoCRM.",
  );
  if (typeof record.expiresAt !== "string" || Number.isNaN(Date.parse(record.expiresAt))) {
    throw new ApiRequestError("Сервер не указал срок действия авторизации amoCRM.");
  }
  return { authorizationUrl, callbackUrl, expiresAt: record.expiresAt };
}

function parseAmoCrmReverificationResult(payload: unknown): AmoCrmReverificationResult {
  const record = payloadRecord(payload, "Сервер не подтвердил доступ к amoCRM.");
  const account = payloadRecord(record.account, "Сервер не подтвердил аккаунт amoCRM.");
  const counts = [record.pipelineCount, record.stageCount, record.activeUserCount];
  if (
    record.status !== "ready"
    || typeof account.id !== "string"
    || account.id.length === 0
    || typeof account.domain !== "string"
    || account.domain.length === 0
    || typeof account.name !== "string"
    || account.name.length === 0
    || !counts.every((count) => Number.isInteger(count) && Number(count) >= 0)
    || typeof record.accessTokenRefreshed !== "boolean"
  ) {
    throw new ApiRequestError("Сервер вернул несовместимый результат проверки amoCRM.");
  }
  return {
    status: "ready",
    account: { id: account.id, domain: account.domain, name: account.name },
    pipelineCount: record.pipelineCount as number,
    stageCount: record.stageCount as number,
    activeUserCount: record.activeUserCount as number,
    accessTokenRefreshed: record.accessTokenRefreshed,
  };
}

function parseEmployeeMutationResult(payload: unknown): EmployeeMutationResult {
  const record = payloadRecord(payload, "Сервер не подтвердил сохранение ИИ-сотрудника.");
  return {
    employeeId: requiredUuid(record, "employeeId", "Сервер вернул некорректный профиль ИИ-сотрудника."),
  };
}

function parseScenarioMutationResult(payload: unknown): ScenarioMutationResult {
  const record = payloadRecord(payload, "Сервер не подтвердил публикацию сценария.");
  return {
    scenarioId: requiredUuid(record, "scenarioId", "Сервер вернул некорректную версию сценария."),
  };
}

export async function fetchBootstrap(scope?: "calendar"): Promise<{
  bootstrap: AppBootstrap;
  csrfToken: string | null;
}> {
  const timer = withTimeout();
  try {
    const response = await fetch(scope === "calendar" ? "/api/app/bootstrap?scope=calendar" : "/api/app/bootstrap", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    const payload: unknown = await response.json();
    const bootstrap = AppBootstrapSchema.parse(payload);
    return {
      bootstrap,
      csrfToken: response.headers.get("x-csrf-token"),
    };
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(
        "Сервер не ответил вовремя. Состояние рабочей базы и отправки не подтверждено.",
        { code: "BOOTSTRAP_TIMEOUT" },
      );
    }
    throw new ApiRequestError(
      "Нет связи с сервером. Состояние рабочей базы и отправки не подтверждено.",
      { code: "BOOTSTRAP_UNAVAILABLE" },
    );
  } finally {
    timer.dispose();
  }
}

export async function updateDeliveryState(
  mutation: DeliveryStateMutation,
  csrfToken: string | null,
): Promise<DeliveryState> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/safety/delivery", {
      method: "PUT",
      credentials: "include",
      headers: mutationHeaders(csrfToken),
      body: JSON.stringify(mutation),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return DeliveryStateSchema.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(
        "Сервер не подтвердил изменение вовремя. Режим не изменён.",
      );
    }
    throw new ApiRequestError(
      "Не удалось подтвердить изменение на сервере. Режим не изменён.",
    );
  } finally {
    timer.dispose();
  }
}

/** «Диалоги» read only their part of the snapshot: these chats (at most 100), the employees, scenarios, stages and
 * media — not the 200 newest dialogs and the agents', knowledge, schedule and audit sections (17.10.2026: 2–4 s). */
export type WorkspaceDialogsRead = Readonly<{ conversationIds: readonly string[] }>;
export const WORKSPACE_DIALOGS_READ_LIMIT = 100;

export async function fetchWorkspace(
  reviewConversationId?: string,
  reviewPreviewFenceId?: string,
  timeoutMs = WORKSPACE_READ_TIMEOUT_MS,
  dialogs?: WorkspaceDialogsRead,
): Promise<WorkspaceSnapshot> {
  const query = new URLSearchParams();
  if (reviewConversationId) query.set("reviewConversationId", reviewConversationId);
  if (reviewPreviewFenceId) query.set("reviewPreviewFenceId", reviewPreviewFenceId);
  if (dialogs) {
    query.set("scope", "dialogs");
    // Sorted: the same chats are one pending read.
    if (dialogs.conversationIds.length > 0) query.set("conversationIds", [...new Set(dialogs.conversationIds)].sort().join(","));
  }
  const serializedQuery = query.size > 0 ? `?${query.toString()}` : "";
  const path = `/api/workspace${serializedQuery}`;
  let pending = pendingWorkspaceReads.get(path);
  if (!pending) {
    pending = {
      promise: readWorkspace(path),
      timedOut: false,
      retentionTimer: null,
    };
    pendingWorkspaceReads.set(path, pending);
    const created = pending;
    void created.promise.then(
      () => {
        if (pendingWorkspaceReads.get(path) !== created) return;
        if (!created.timedOut) {
          pendingWorkspaceReads.delete(path);
          return;
        }
        created.retentionTimer = window.setTimeout(() => {
          if (pendingWorkspaceReads.get(path) === created) pendingWorkspaceReads.delete(path);
        }, WORKSPACE_RECOVERY_TIMEOUT_MS);
      },
      () => {
        if (pendingWorkspaceReads.get(path) === created) pendingWorkspaceReads.delete(path);
      },
    );
  }
  const selected = pending;
  return withSoftTimeout(selected.promise, timeoutMs, () => new ApiRequestError(
    "Рабочие данные не загрузились вовремя.",
    { code: "WORKSPACE_TIMEOUT" },
  ), () => {
    selected.timedOut = true;
  }).then((workspace) => {
    if (selected.timedOut && pendingWorkspaceReads.get(path) === selected) {
      if (selected.retentionTimer !== null) window.clearTimeout(selected.retentionTimer);
      pendingWorkspaceReads.delete(path);
    }
    return workspace;
  });
}

async function readWorkspace(path: string): Promise<WorkspaceSnapshot> {
  try {
    const response = await fetch(path, {
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw await parseError(response);
    const parsed = WorkspaceSnapshotSchema.safeParse(await response.json());
    if (!parsed.success) {
      throw new ApiRequestError(
        "Сервер вернул несовместимый снимок рабочего пространства.",
        { code: "INVALID_WORKSPACE_RESPONSE" },
      );
    }
    return parsed.data;
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    throw new ApiRequestError("Не удалось загрузить рабочие данные с сервера.", {
      code: "WORKSPACE_UNAVAILABLE",
    });
  }
}

export async function acknowledgePostBookingPreview(
  conversationId: string,
  mutation: PostBookingPreviewReviewMutation,
  csrfToken: string | null,
): Promise<void> {
  const body = PostBookingPreviewReviewMutationSchema.parse(mutation);
  await authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/post-booking-preview/review`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = PostBookingPreviewReviewResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер не подтвердил просмотр пакета записи.");
      }
      return parsed.data;
    },
  });
}

export async function fetchCrmDeals(input: Partial<CrmDealListQuery> = {}): Promise<CrmDealList> {
  const query = CrmDealListQuerySchema.parse(input);
  const search = new URLSearchParams();
  if (query.search) search.set("search", query.search);
  query.employeeIds.forEach((value) => search.append("employeeIds", value));
  query.scenarioIds.forEach((value) => search.append("scenarioIds", value));
  search.set("conversationPresence", query.conversationPresence);
  search.set("requiresAttention", String(query.requiresAttention));
  query.pipelineIds.forEach((value) => search.append("pipelineIds", value));
  query.stageIds.forEach((value) => search.append("stageIds", value));
  query.replyStates.forEach((value) => search.append("replyStates", value));
  query.controlModes.forEach((value) => search.append("controlModes", value));
  query.channels.forEach((value) => search.append("channels", value));
  query.helpReasons.forEach((value) => search.append("helpReasons", value));
  query.dealIds.forEach((value) => search.append("dealIds", value));
  if (query.cursor) search.set("cursor", query.cursor);
  search.set("limit", String(query.limit));
  return authenticatedJsonQuery({
    path: `/api/deals?${search.toString()}`,
    parse: (payload) => CrmDealListSchema.parse(payload),
    timeoutMessage: "Сделки не загрузились вовремя.",
    timeoutCode: "CRM_DEALS_TIMEOUT",
    failureMessage: "Не удалось загрузить сделки из рабочего пространства.",
    failureCode: "CRM_DEALS_UNAVAILABLE",
  });
}

/** Events of the deal's chats for the timeline (decisions, checks, stops). */
export async function fetchCrmDealEvents(dealId: string, conversationId: string | null = null): Promise<CrmDealEvents> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  const search = new URLSearchParams();
  if (conversationId) search.set("conversationId", conversationId);
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}/events${suffix}`,
    parse: (payload) => CrmDealEventsSchema.parse(payload),
    timeoutMessage: "События диалога не загрузились вовремя.",
    timeoutCode: "CRM_DEAL_EVENTS_TIMEOUT",
    failureMessage: "Не удалось загрузить события диалога.",
    failureCode: "CRM_DEAL_EVENTS_UNAVAILABLE",
  });
}

/** «Яна за день»: dialogs of one Moscow day of the AI employee's work. */
export async function fetchYanaDay(input: YanaDayQuery): Promise<YanaDay> {
  const query = YanaDayQuerySchema.parse(input);
  const search = new URLSearchParams({ date: query.date });
  query.employeeIds.forEach((value) => search.append("employeeIds", value));
  return authenticatedJsonQuery({
    path: `/api/deals/yana-day?${search.toString()}`,
    parse: (payload) => YanaDaySchema.parse(payload),
    timeoutMessage: "Работа Яны за день не загрузилась вовремя.",
    timeoutCode: "YANA_DAY_TIMEOUT",
    failureMessage: "Не удалось загрузить работу Яны за день.",
    failureCode: "YANA_DAY_UNAVAILABLE",
  });
}

export async function fetchGipnoActionLog(
  input: Partial<GipnoActionLogQuery> = {},
): Promise<GipnoActionLog> {
  const query = GipnoActionLogQuerySchema.parse(input);
  const search = new URLSearchParams();
  query.employeeIds.forEach((value) => search.append("employeeIds", value));
  query.scenarioIds.forEach((value) => search.append("scenarioIds", value));
  search.set("messagesOnly", String(query.messagesOnly));
  query.connectorKinds.forEach((value) => search.append("connectorKinds", value));
  query.states.forEach((value) => search.append("states", value));
  search.set("periodKind", query.periodKind);
  if (query.from) search.set("from", query.from);
  if (query.to) search.set("to", query.to);
  if (query.cursor) search.set("cursor", query.cursor);
  search.set("limit", String(query.limit));
  return authenticatedJsonQuery({
    path: `/api/gipno/action-log?${search.toString()}`,
    parse: (payload) => GipnoActionLogSchema.parse(payload),
    timeoutMessage: "Журнал действий не загрузился вовремя.",
    timeoutCode: "GIPNO_ACTION_LOG_TIMEOUT",
    failureMessage: "Не удалось загрузить журнал действий.",
    failureCode: "GIPNO_ACTION_LOG_UNAVAILABLE",
  });
}

export async function fetchCrmDeal(dealId: string): Promise<CrmDealDetail> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}`,
    parse: (payload) => CrmDealDetailSchema.parse(payload),
    timeoutMessage: "Карточка сделки не загрузилась вовремя.",
    timeoutCode: "CRM_DEAL_TIMEOUT",
    failureMessage: "Не удалось загрузить карточку сделки.",
    failureCode: "CRM_DEAL_UNAVAILABLE",
  });
}

/** A report of an agent (`/report/<id>`, 04.11.2026): the page by its kind, for a reader of its section. */
export async function fetchReport(id: string): Promise<ReportView> {
  if (!UUID_PATTERN.test(id)) throw new ApiRequestError("Такого отчёта нет.", { code: "REPORT_ID_INVALID" });
  return authenticatedJsonQuery({
    path: `/api/reports/${encodeURIComponent(id)}`,
    parse: (payload) => ReportViewSchema.parse(payload),
    timeoutMessage: "Отчёт не загрузился вовремя.",
    timeoutCode: "REPORT_TIMEOUT",
    failureMessage: "Отчёт не загрузился.",
    failureCode: "REPORT_UNAVAILABLE",
  });
}

/** The server's qualification decision for the chosen chat of the deal (or its latest chat). */
export async function fetchCrmDealQualification(dealId: string, conversationId: string | null): Promise<DealQualification> {
  if (!UUID_PATTERN.test(dealId) || (conversationId !== null && !UUID_PATTERN.test(conversationId))) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  const query = conversationId === null ? "" : `?${new URLSearchParams({ conversationId })}`;
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}/qualification${query}`,
    parse: (payload) => DealQualificationSchema.parse(payload),
    timeoutMessage: "Квалификация не загрузилась вовремя.",
    timeoutCode: "CRM_DEAL_QUALIFICATION_TIMEOUT",
    failureMessage: "Не удалось проверить квалификацию.",
    failureCode: "CRM_DEAL_QUALIFICATION_UNAVAILABLE",
  });
}

/** Every chat of the deal's person (also under another deal) and where a new chat can be opened, with health. */
export async function fetchCrmDealContactChannels(dealId: string): Promise<ContactChannelList> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}/contact-channels`,
    parse: (payload) => ContactChannelListSchema.parse(payload),
    timeoutMessage: "Каналы клиента не загрузились вовремя.",
    timeoutCode: "CRM_DEAL_CHANNELS_TIMEOUT",
    failureMessage: "Не удалось загрузить каналы клиента.",
    failureCode: "CRM_DEAL_CHANNELS_UNAVAILABLE",
  });
}

export async function fetchCrmDealTimeline(
  dealId: string,
  input: Partial<CrmDealTimelineQuery> = {},
): Promise<CrmDealTimeline> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  const query = CrmDealTimelineQuerySchema.parse(input);
  const search = new URLSearchParams({ limit: String(query.limit) });
  if (query.conversationId) search.set("conversationId", query.conversationId);
  if (query.cursor) search.set("cursor", query.cursor);
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}/timeline?${search.toString()}`,
    parse: (payload) => CrmDealTimelineSchema.parse(payload),
    timeoutMessage: "История сделки не загрузилась вовремя.",
    timeoutCode: "CRM_DEAL_TIMELINE_TIMEOUT",
    failureMessage: "Не удалось загрузить переписку по сделке.",
    failureCode: "CRM_DEAL_TIMELINE_UNAVAILABLE",
  });
}

// A named change, or `null` when the screen must re-read fully: the stream
// reconnected (events in the gap are unknown) or the server could not name it.
export type DialogLiveSignal = DialogLiveChange | null;

let sharedDialogLiveSource: EventSource | null = null;
const sharedDialogLiveListeners = new Set<(signal: DialogLiveSignal) => void>();

export function parseDialogLiveChange(data: string): DialogLiveSignal {
  try {
    const parsed = DialogLiveChangeSchema.safeParse(JSON.parse(data));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

function ensureDialogLiveSource(): EventSource {
  if (sharedDialogLiveSource) return sharedDialogLiveSource;
  const source = new EventSource("/api/dialogs/events", { withCredentials: true });
  const notify = (signal: DialogLiveSignal) => {
    for (const listener of sharedDialogLiveListeners) listener(signal);
  };
  let connected = false;
  source.addEventListener("ready", () => {
    // The first connection is covered by the screen's own initial read.
    if (connected) notify(null);
    connected = true;
  });
  source.addEventListener("resync", () => notify(null));
  source.addEventListener("deals", (event) => {
    notify(parseDialogLiveChange((event as MessageEvent<string>).data));
  });
  sharedDialogLiveSource = source;
  return source;
}

export function subscribeDialogLive(onChanged: (signal: DialogLiveSignal) => void): () => void {
  sharedDialogLiveListeners.add(onChanged);
  ensureDialogLiveSource();
  return () => {
    sharedDialogLiveListeners.delete(onChanged);
    if (sharedDialogLiveListeners.size > 0) return;
    sharedDialogLiveSource?.close();
    sharedDialogLiveSource = null;
  };
}

export async function markCrmDealNoReplyNeeded(
  dealId: string,
  input: CrmDealNoReplyMutation,
  csrfToken: string | null,
): Promise<CrmDealNoReplyResult> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", {
      code: "CRM_DEAL_ID_INVALID",
    });
  }
  return authenticatedJsonMutation({
    path: `/api/deals/${encodeURIComponent(dealId)}/no-reply-needed`,
    method: "POST",
    csrfToken,
    body: CrmDealNoReplyMutationSchema.parse(input),
    parse: (payload) => CrmDealNoReplyResultSchema.parse(payload),
  });
}

export async function adviseOwnerEscalation(
  escalationId: string,
  input: OwnerEscalationAdviceMutation,
  csrfToken: string | null,
): Promise<OwnerEscalationAdviceResult> {
  if (!UUID_PATTERN.test(escalationId)) {
    throw new ApiRequestError("Некорректный идентификатор эскалации.", {
      code: "OWNER_ESCALATION_ID_INVALID",
    });
  }
  return authenticatedJsonMutation({
    path: `/api/owner-escalations/${encodeURIComponent(escalationId)}/advice`,
    method: "POST",
    csrfToken,
    body: OwnerEscalationAdviceMutationSchema.parse(input),
    parse: (payload) => OwnerEscalationAdviceResultSchema.parse(payload),
  });
}

export async function requestCrmDealReconciliation(
  input: CrmDealReconciliationMutation,
  csrfToken: string | null,
): Promise<CrmDealReconciliationResult> {
  return authenticatedJsonMutation({
    path: "/api/deals/reconciliation",
    method: "POST",
    csrfToken,
    body: CrmDealReconciliationMutationSchema.parse(input),
    parse: (payload) => CrmDealReconciliationResultSchema.parse(payload),
  });
}

export async function resolveCrmDealConversationLink(
  dealId: string,
  input: CrmDealLinkResolutionMutation,
  csrfToken: string | null,
): Promise<CrmDealLinkResolutionResult> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  return authenticatedJsonMutation({
    path: `/api/deals/${encodeURIComponent(dealId)}/conversation-links/resolve`,
    method: "POST",
    csrfToken,
    body: CrmDealLinkResolutionMutationSchema.parse(input),
    parse: (payload) => CrmDealLinkResolutionResultSchema.parse(payload),
  });
}

export async function fetchTeamAccess(): Promise<TeamAccessSnapshot> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/team", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    const parsed = TeamAccessSnapshotSchema.safeParse(await response.json());
    if (!parsed.success) {
      throw new ApiRequestError("Сервер вернул несовместимый состав команды.", {
        code: "INVALID_TEAM_ACCESS_RESPONSE",
      });
    }
    return parsed.data;
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError("Состав команды не загрузился вовремя.", {
        code: "TEAM_ACCESS_TIMEOUT",
      });
    }
    throw new ApiRequestError("Не удалось загрузить подтверждённый состав команды.", {
      code: "TEAM_ACCESS_UNAVAILABLE",
    });
  } finally {
    timer.dispose();
  }
}

/** «Доступ → Команда»: the team list with what each program knows of every person. */
export async function fetchTeamReadiness(): Promise<TeamReadiness> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/team/readiness", { credentials: "include", headers: { Accept: "application/json" }, signal: timer.signal });
    if (!response.ok) throw await parseError(response);
    const parsed = TeamReadinessSchema.safeParse(await response.json());
    if (!parsed.success) throw new ApiRequestError("Сервер вернул несовместимый список команды.", { code: "INVALID_TEAM_READINESS_RESPONSE" });
    return parsed.data;
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    throw new ApiRequestError("Не удалось загрузить список команды.", { code: "TEAM_READINESS_UNAVAILABLE" });
  } finally {
    timer.dispose();
  }
}

/** The invitation of a person of the team list: Vekha resolves the mail, the group «Консультанты» and her consultant. */
export function inviteFromTeamRoster(mutation: TeamRosterInvite, csrfToken: string | null): Promise<TeamOneTimeGrant> {
  const body = TeamRosterInviteSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/team/readiness/invite", method: "POST", csrfToken, body,
    parse: (payload) => TeamOneTimeGrantSchema.parse(payload),
  });
}

export function createTeamInvitation(
  mutation: TeamInvitationCreate,
  csrfToken: string | null,
): Promise<TeamOneTimeGrant> {
  const body = TeamInvitationCreateSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/team/invitations",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => TeamOneTimeGrantSchema.parse(payload),
  });
}

export function revokeTeamInvitation(
  invitationId: string,
  mutation: TeamInvitationRevoke,
  csrfToken: string | null,
): Promise<TeamMutationResult> {
  const body = TeamInvitationRevokeSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/team/invitations/${encodeURIComponent(invitationId)}/revoke`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => TeamMutationResultSchema.parse(payload),
  });
}

export function changeTeamMemberRole(
  membershipId: string,
  mutation: TeamRoleChange,
  csrfToken: string | null,
): Promise<TeamMutationResult> {
  const body = TeamRoleChangeSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/team/members/${encodeURIComponent(membershipId)}/role`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => TeamMutationResultSchema.parse(payload),
  });
}

export function deactivateTeamMember(
  membershipId: string,
  mutation: TeamMemberDeactivate,
  csrfToken: string | null,
): Promise<TeamMutationResult> {
  const body = TeamMemberDeactivateSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/team/members/${encodeURIComponent(membershipId)}/deactivate`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => TeamMutationResultSchema.parse(payload),
  });
}

export function createTeamPasswordReset(
  membershipId: string,
  mutation: TeamPasswordResetCreate,
  csrfToken: string | null,
): Promise<TeamOneTimeGrant> {
  const body = TeamPasswordResetCreateSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/team/members/${encodeURIComponent(membershipId)}/password-reset`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => TeamOneTimeGrantSchema.parse(payload),
  });
}

export function createTeamRestoreReprovision(
  membershipId: string,
  mutation: TeamRestoreReprovisionCreate,
  csrfToken: string | null,
): Promise<TeamOneTimeGrant> {
  const body = TeamRestoreReprovisionCreateSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/team/members/${encodeURIComponent(membershipId)}/restore-invitation`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => TeamOneTimeGrantSchema.parse(payload),
  });
}

export function acceptTeamInvitation(
  mutation: TeamInvitationAccept,
): Promise<TeamAccessAcceptResult> {
  const body = TeamInvitationAcceptSchema.parse(mutation);
  return publicJsonMutation({
    path: "/api/access/invitations/accept",
    body,
    parse: (payload) => TeamAccessAcceptResultSchema.parse(payload),
  });
}

export function requestPasswordRecovery(email: string): Promise<{ accepted: true }> {
  return publicJsonMutation({
    path: "/api/access/password-resets/request",
    body: PasswordRecoveryRequestSchema.parse({ email }),
    parse: (payload) => PasswordRecoveryRequestedSchema.parse(payload),
  });
}

export function acceptTeamPasswordReset(
  mutation: TeamPasswordResetAccept,
): Promise<TeamAccessAcceptResult> {
  const body = TeamPasswordResetAcceptSchema.parse(mutation);
  return publicJsonMutation({
    path: "/api/access/password-resets/accept",
    body,
    parse: (payload) => TeamAccessAcceptResultSchema.parse(payload),
  });
}

export async function fetchRestoreSafety(): Promise<RestoreSafetyState> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/safety/restore", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    const parsed = RestoreSafetyStateSchema.safeParse(await response.json());
    if (!parsed.success) {
      throw new ApiRequestError(
        "Сервер вернул несовместимое состояние защиты после восстановления.",
        { code: "INVALID_RESTORE_SAFETY_RESPONSE" },
      );
    }
    return parsed.data;
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError(
        "Сервер не подтвердил защиту после восстановления вовремя. Изменение отправки заблокировано.",
        { code: "RESTORE_SAFETY_TIMEOUT" },
      );
    }
    throw new ApiRequestError(
      "Не удалось подтвердить защиту после восстановления. Изменение отправки заблокировано.",
      { code: "RESTORE_SAFETY_UNAVAILABLE" },
    );
  } finally {
    timer.dispose();
  }
}

export async function reconcileRestoreSafety(
  mutation: RestoreReconciliationMutation,
  csrfToken: string | null,
): Promise<RestoreSafetyState> {
  const body = RestoreReconciliationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/safety/restore/reconcile",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = RestoreSafetyStateSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError(
          "Сервер вернул неполное состояние после сверки восстановленной базы.",
          { code: "INVALID_RESTORE_SAFETY_RESPONSE" },
        );
      }
      return parsed.data;
    },
  });
}

export async function editDraftRevision(
  draftRevisionId: string,
  mutation: DraftEdit,
  csrfToken: string | null,
): Promise<DraftEditResult> {
  const body = DraftEditSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/drafts/${encodeURIComponent(draftRevisionId)}/revisions`,
    method: "POST",
    csrfToken,
    body,
    parse: parseDraftEditResult,
  });
}

export async function decideDraftRevision(
  draftRevisionId: string,
  mutation: DraftDecision,
  csrfToken: string | null,
): Promise<DraftDecisionResult> {
  const body = DraftDecisionSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/drafts/${encodeURIComponent(draftRevisionId)}/decision`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = DraftDecisionResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер вернул неполный результат решения по черновику.");
      }
      return parsed.data;
    },
  });
}

export async function updateConversationAllowlist(
  conversationId: string,
  mutation: AllowlistMutation,
  csrfToken: string | null,
): Promise<AllowlistMutationResult> {
  const body = AllowlistMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/allowlist`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = AllowlistMutationResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер вернул неполный результат изменения разрешённой сделки.");
      }
      return parsed.data;
    },
  });
}

export async function updateConversationPreviewProcessing(
  conversationId: string,
  mutation: PreviewProcessingGrantMutation,
  csrfToken: string | null,
): Promise<PreviewProcessingGrantMutationResult> {
  const body = PreviewProcessingGrantMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/preview-processing`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = PreviewProcessingGrantMutationResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError(
          "Сервер вернул неполный результат изменения режима предпросмотра.",
        );
      }
      return parsed.data;
    },
  });
}

export async function updateScenarioPreviewPilot(
  scenarioId: string,
  mutation: PreviewPilotScopeMutation,
  csrfToken: string | null,
): Promise<PreviewPilotScopeMutationResult> {
  const body = PreviewPilotScopeMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/scenarios/${encodeURIComponent(scenarioId)}/preview-pilot`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = PreviewPilotScopeMutationResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError(
          "Сервер вернул неполный результат изменения предпросмотра этапа.",
        );
      }
      return parsed.data;
    },
  });
}

export async function recoverConversation(
  conversationId: string,
  mutation: ConversationRecovery,
  csrfToken: string | null,
): Promise<ConversationRecoveryResult> {
  const body = ConversationRecoverySchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/recovery`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = ConversationRecoveryResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер вернул неполный результат повторной подготовки ответа.");
      }
      return parsed.data;
    },
  });
}

export async function retryFirstContact(
  conversationId: string,
  effectId: string,
  mutation: FirstContactRetryMutation,
  csrfToken: string | null,
): Promise<FirstContactRetryResult> {
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/deliveries/${encodeURIComponent(effectId)}/retry-first-contact`,
    method: "POST",
    csrfToken,
    body: FirstContactRetryMutationSchema.parse(mutation),
    parse: (payload) => {
      const parsed = FirstContactRetryResultSchema.safeParse(payload);
      if (!parsed.success) throw new ApiRequestError("Сервер вернул неполный результат повтора отправки.");
      return parsed.data;
    },
  });
}

export async function fetchOwnerLeadReturnOptions(
  conversationId: string,
): Promise<OwnerLeadReturnOptions> {
  return authenticatedJsonQuery({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/owner-return`,
    parse: (payload) => {
      const parsed = OwnerLeadReturnOptionsSchema.safeParse(payload);
      if (!parsed.success) throw new ApiRequestError("Сервер вернул неполные данные для возврата лида.");
      return parsed.data;
    },
    timeoutMessage: "Сервер не ответил вовремя. Повторите.",
    timeoutCode: "REQUEST_TIMEOUT",
    failureMessage: "Не удалось загрузить данные для возврата лида.",
    failureCode: "REQUEST_FAILED",
  });
}

/** «Вернуть лид Яне / поставить проверку»: never writes to the customer. */
export async function returnLeadToYana(
  conversationId: string,
  mutation: OwnerLeadReturnMutation,
  csrfToken: string | null,
): Promise<OwnerLeadReturnResult> {
  const body = OwnerLeadReturnMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/owner-return`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = OwnerLeadReturnResultSchema.safeParse(payload);
      if (!parsed.success) throw new ApiRequestError("Сервер вернул неполный результат возврата лида.");
      return parsed.data;
    },
  });
}

export async function updateConversationControl(
  conversationId: string,
  mutation: ConversationControlMutation,
  csrfToken: string | null,
): Promise<ConversationControlResult> {
  const body = ConversationControlMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/control`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = ConversationControlResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер вернул неполный результат передачи диалога.");
      }
      return parsed.data;
    },
  });
}

export async function updateConversationKind(
  conversationId: string,
  mutation: ConversationKindMutation,
  csrfToken: string | null,
): Promise<ConversationKindResult> {
  const body = ConversationKindMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/kind`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = ConversationKindResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError("Сервер вернул неполный результат классификации диалога.");
      }
      return parsed.data;
    },
  });
}

export async function regeneratePolicyPreview(
  conversationId: string,
  mutation: ConversationPolicyRegeneration,
  csrfToken: string | null,
): Promise<ConversationPolicyRegenerationResult> {
  const body = ConversationPolicyRegenerationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/conversations/${encodeURIComponent(conversationId)}/policy-regeneration`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => {
      const parsed = ConversationPolicyRegenerationResultSchema.safeParse(payload);
      if (!parsed.success) {
        throw new ApiRequestError(
          "Сервер вернул неполный результат подготовки нового варианта.",
        );
      }
      return parsed.data;
    },
  });
}

export async function saveWazzupConnector(
  mutation: WazzupIntegrationMutation,
  csrfToken: string | null,
): Promise<WazzupIntegrationResult> {
  const confirmation = PrivilegedConfirmationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/integrations/wazzup",
    method: "PUT",
    csrfToken,
    body: {
      installationId: mutation.installationId,
      apiKey: mutation.apiKey,
      confirmAccountWebhookTakeover: mutation.confirmAccountWebhookTakeover,
      ...confirmation,
    },
    parse: parseWazzupIntegrationResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function saveGoogleSheetsConnector(
  mutation: GoogleSheetsIntegrationMutation,
  csrfToken: string | null,
): Promise<GoogleSheetsIntegrationResult> {
  const confirmation = PrivilegedConfirmationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/integrations/google-sheets",
    method: "PUT",
    csrfToken,
    body: {
      installationId: mutation.installationId,
      serviceAccountJson: mutation.serviceAccountJson,
      spreadsheetId: mutation.spreadsheetId,
      ...confirmation,
    },
    parse: parseGoogleSheetsIntegrationResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function startGoogleSheetsOAuth(
  mutation: GoogleSheetsOAuthStartMutation,
  csrfToken: string | null,
): Promise<GoogleSheetsOAuthStartResult> {
  const confirmation = PrivilegedConfirmationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/integrations/google-sheets/oauth/start",
    method: "POST",
    csrfToken,
    body: {
      installationId: mutation.installationId,
      ...confirmation,
    },
    parse: parseGoogleSheetsOAuthStartResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function verifyGoogleSheetsSpreadsheet(
  mutation: GoogleSheetsSpreadsheetMutation,
  csrfToken: string | null,
): Promise<GoogleSheetsSpreadsheetResult> {
  return authenticatedJsonMutation({
    path: "/api/integrations/google-sheets/spreadsheet",
    method: "PUT",
    csrfToken,
    body: mutation,
    parse: parseGoogleSheetsSpreadsheetResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function startAmoCrmOAuth(
  mutation: AmoOAuthStartMutation,
  csrfToken: string | null,
): Promise<AmoOAuthStartResult> {
  const confirmation = PrivilegedConfirmationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/integrations/amocrm/oauth/start",
    method: "POST",
    csrfToken,
    body: {
      installationId: mutation.installationId,
      clientId: mutation.clientId,
      clientSecret: mutation.clientSecret,
      mode: mutation.mode,
      ...confirmation,
    },
    parse: parseAmoOAuthStartResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function reconnectAmoCrmOAuth(
  installationId: string,
  csrfToken: string | null,
): Promise<AmoOAuthStartResult> {
  return authenticatedJsonMutation({
    path: "/api/integrations/amocrm/oauth/reconnect",
    method: "POST",
    csrfToken,
    body: { installationId, mode: "popup" },
    parse: parseAmoOAuthStartResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function reverifyAmoCrmConnector(
  mutation: AmoCrmReverificationMutation,
  csrfToken: string | null,
): Promise<AmoCrmReverificationResult> {
  const confirmation = PrivilegedConfirmationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/integrations/amocrm/reverify",
    method: "POST",
    csrfToken,
    body: {
      installationId: mutation.installationId,
      ...confirmation,
    },
    parse: parseAmoCrmReverificationResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function refreshAmoCrmCatalogs(
  mutation: { installationId: string },
  csrfToken: string | null,
): Promise<AmoCrmReverificationResult> {
  return authenticatedJsonMutation({
    path: "/api/integrations/amocrm/catalogs/refresh",
    method: "POST",
    csrfToken,
    body: { installationId: mutation.installationId },
    parse: parseAmoCrmReverificationResult,
    timeoutMs: INTEGRATION_TIMEOUT_MS,
  });
}

export async function createEmployeeProfile(
  mutation: EmployeeMutation,
  csrfToken: string | null,
): Promise<EmployeeMutationResult> {
  const body = EmployeeMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/employees",
    method: "POST",
    csrfToken,
    body,
    parse: parseEmployeeMutationResult,
  });
}

export async function updateEmployeeProfile(
  employeeId: string,
  mutation: EmployeeMutation,
  csrfToken: string | null,
): Promise<EmployeeMutationResult> {
  const body = EmployeeMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/employees/${encodeURIComponent(employeeId)}`,
    method: "PUT",
    csrfToken,
    body,
    parse: parseEmployeeMutationResult,
  });
}

export async function publishEmployeeVersion(
  employeeId: string,
  mutation: EmployeeVersionPublicationMutation,
  csrfToken: string | null,
): Promise<EmployeeVersionPublicationResult> {
  const body = EmployeeVersionPublicationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/employees/${encodeURIComponent(employeeId)}/versions`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => EmployeeVersionPublicationResultSchema.parse(payload),
  });
}

export async function createWorkflowScenario(
  mutation: WorkflowScenarioCreateMutation,
  csrfToken: string | null,
): Promise<WorkflowScenarioCreateResult> {
  const body = WorkflowScenarioCreateMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/workflow-scenarios",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => WorkflowScenarioCreateResultSchema.parse(payload),
  });
}

export async function publishScenarioWorkflow(
  scenarioId: string,
  mutation: ScenarioWorkflowPublicationMutation,
  csrfToken: string | null,
): Promise<ScenarioWorkflowPublicationResult> {
  const body = ScenarioWorkflowPublicationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/scenarios/${encodeURIComponent(scenarioId)}/versions`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScenarioWorkflowPublicationResultSchema.parse(payload),
  });
}

export async function startHistoricalReplay(
  mutation: HistoricalReplayStartMutation,
  csrfToken: string | null,
): Promise<HistoricalReplayStartResult> {
  const body = HistoricalReplayStartMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/historical-replays",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => HistoricalReplayStartResultSchema.parse(payload),
  });
}

export async function fetchHistoricalReplayScheduleSnapshot(
  request: HistoricalReplayScheduleSnapshotRequest,
): Promise<HistoricalReplayScheduleSnapshotResult> {
  const parsed = HistoricalReplayScheduleSnapshotRequestSchema.parse(request);
  const query = new URLSearchParams({
    scenarioVersionId: parsed.scenarioVersionId,
    stageNodeIds: parsed.stageNodeIds.join(","),
  });
  return authenticatedJsonQuery({
    path: `/api/historical-replays/schedule-snapshot?${query.toString()}`,
    parse: (payload) => HistoricalReplayScheduleSnapshotResultSchema.parse(payload),
    timeoutMessage: "Сервер не успел прочитать свободные слоты активного графика.",
    timeoutCode: "HISTORICAL_REPLAY_SCHEDULE_TIMEOUT",
    failureMessage: "Не удалось подготовить снимок расписания для проверки.",
    failureCode: "HISTORICAL_REPLAY_SCHEDULE_FAILED",
  });
}

export async function importHistoricalCases(
  mutation: HistoricalCaseImportMutation,
  csrfToken: string | null,
): Promise<HistoricalCaseImportResult> {
  const body = HistoricalCaseImportMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/historical-cases/import",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => HistoricalCaseImportResultSchema.parse(payload),
  });
}

export async function fetchHistoricalCases(): Promise<readonly HistoricalCaseSummary[]> {
  return authenticatedJsonQuery({
    path: "/api/historical-cases",
    parse: (payload) => HistoricalCaseSummariesSchema.parse(payload),
    timeoutMessage: "Сервер не успел загрузить архивные диалоги.",
    timeoutCode: "HISTORICAL_CASES_TIMEOUT",
    failureMessage: "Не удалось загрузить архивные диалоги.",
    failureCode: "HISTORICAL_CASES_FAILED",
  });
}

export async function fetchHistoricalReplays(): Promise<readonly HistoricalReplayRun[]> {
  return authenticatedJsonQuery({
    path: "/api/historical-replays",
    parse: (payload) => HistoricalReplayRunsSchema.parse(payload),
    timeoutMessage: "Сервер не успел загрузить исторические проверки.",
    timeoutCode: "HISTORICAL_REPLAYS_TIMEOUT",
    failureMessage: "Не удалось загрузить исторические проверки.",
    failureCode: "HISTORICAL_REPLAYS_FAILED",
  });
}

export async function fetchHistoricalReplay(
  replayRunId: string,
): Promise<HistoricalReplayRun> {
  return authenticatedJsonQuery({
    path: `/api/historical-replays/${encodeURIComponent(replayRunId)}`,
    parse: (payload) => HistoricalReplayRunSchema.parse(payload),
    timeoutMessage: "Сервер не успел обновить историческую проверку.",
    timeoutCode: "HISTORICAL_REPLAY_TIMEOUT",
    failureMessage: "Не удалось обновить историческую проверку.",
    failureCode: "HISTORICAL_REPLAY_FAILED",
  });
}

export async function startScenarioSimulation(
  mutation: ScenarioSimulationSessionStartMutation,
  csrfToken: string | null,
): Promise<ScenarioSimulationMutationResult> {
  const body = ScenarioSimulationSessionStartMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/scenario-simulations",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScenarioSimulationMutationResultSchema.parse(payload),
  });
}

export async function addScenarioSimulationTurn(
  simulationSessionId: string,
  mutation: ScenarioSimulationTurnMutation,
  csrfToken: string | null,
): Promise<ScenarioSimulationMutationResult> {
  const body = ScenarioSimulationTurnMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/scenario-simulations/${encodeURIComponent(simulationSessionId)}/turns`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScenarioSimulationMutationResultSchema.parse(payload),
  });
}

export async function fetchScenarioSimulations(): Promise<readonly ScenarioSimulationSession[]> {
  return authenticatedJsonQuery({
    path: "/api/scenario-simulations",
    parse: (payload) => ScenarioSimulationSessionsSchema.parse(payload),
    timeoutMessage: "Сервер не успел загрузить тестовые диалоги.",
    timeoutCode: "SCENARIO_SIMULATIONS_TIMEOUT",
    failureMessage: "Не удалось загрузить тестовые диалоги.",
    failureCode: "SCENARIO_SIMULATIONS_FAILED",
  });
}

export async function fetchScenarioSimulation(
  simulationSessionId: string,
): Promise<ScenarioSimulationSession> {
  return authenticatedJsonQuery({
    path: `/api/scenario-simulations/${encodeURIComponent(simulationSessionId)}`,
    parse: (payload) => ScenarioSimulationSessionSchema.parse(payload),
    timeoutMessage: "Сервер не успел обновить тестовый диалог.",
    timeoutCode: "SCENARIO_SIMULATION_TIMEOUT",
    failureMessage: "Не удалось обновить тестовый диалог.",
    failureCode: "SCENARIO_SIMULATION_FAILED",
  });
}

export async function activateScenarioWorkflow(
  scenarioId: string,
  mutation: ScenarioActivationMutation,
  csrfToken: string | null,
): Promise<ScenarioActivationResult> {
  const body = ScenarioActivationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/scenarios/${encodeURIComponent(scenarioId)}/activations`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScenarioActivationResultSchema.parse(payload),
  });
}

export async function updateWorkflowPreviewPilot(
  scenarioId: string,
  mutation: WorkflowPreviewPilotMutation,
  csrfToken: string | null,
): Promise<WorkflowPreviewPilotResult> {
  const body = WorkflowPreviewPilotMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/workflow-scenarios/${encodeURIComponent(scenarioId)}/preview-pilot`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => WorkflowPreviewPilotResultSchema.parse(payload),
  });
}

export async function updateScenarioOperatingMode(
  scenarioId: string,
  mutation: ScenarioOperatingModeMutation,
  csrfToken: string | null,
): Promise<ScenarioOperatingModeResult> {
  const body = ScenarioOperatingModeMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/workflow-scenarios/${encodeURIComponent(scenarioId)}/operating-mode`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => ScenarioOperatingModeResultSchema.parse(payload),
  });
}

export async function updateScenarioDeliveryWindow(
  scenarioId: string,
  mutation: ScenarioDeliveryWindowMutation,
  csrfToken: string | null,
): Promise<ScenarioDeliveryWindowResult> {
  const body = ScenarioDeliveryWindowMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/workflow-scenarios/${encodeURIComponent(scenarioId)}/delivery-window`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => ScenarioDeliveryWindowResultSchema.parse(payload),
  });
}

export async function updateScenarioResponsibleScope(
  scenarioId: string,
  mutation: ScenarioResponsibleScopeMutation,
  csrfToken: string | null,
): Promise<ScenarioResponsibleScopeResult> {
  const body = ScenarioResponsibleScopeMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/workflow-scenarios/${encodeURIComponent(scenarioId)}/responsible-scope`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => ScenarioResponsibleScopeResultSchema.parse(payload),
  });
}

export async function saveScheduleBindingDraft(
  mutation: ScheduleBindingDraftMutation,
  csrfToken: string | null,
): Promise<ScheduleBindingDraftResult> {
  const body = ScheduleBindingDraftMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/schedule-bindings/draft",
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => ScheduleBindingDraftResultSchema.parse(payload),
  });
}

export async function analyzeGoogleSheetsSchedule(
  installationId: string,
  connectorAccountId: string,
): Promise<GoogleSheetsScheduleAnalysis> {
  const query = new URLSearchParams({ installationId, connectorAccountId });
  return authenticatedJsonQuery({
    path: `/api/schedule-bindings/google-sheets/analysis?${query.toString()}`,
    parse: (payload) => GoogleSheetsScheduleAnalysisSchema.parse(payload),
    timeoutMessage: "VEHA не успела разобрать структуру Google Таблицы.",
    timeoutCode: "SCHEDULE_ANALYSIS_TIMEOUT",
    failureMessage: "Не удалось разобрать Google Таблицу как график.",
    failureCode: "SCHEDULE_ANALYSIS_FAILED",
  });
}

export async function publishScheduleBinding(
  bindingId: string,
  mutation: ScheduleBindingPublicationMutation,
  csrfToken: string | null,
): Promise<ScheduleBindingPublicationResult> {
  const body = ScheduleBindingPublicationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/schedule-bindings/${encodeURIComponent(bindingId)}/versions`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScheduleBindingPublicationResultSchema.parse(payload),
  });
}

export async function activateScheduleBinding(
  bindingId: string,
  mutation: ScheduleBindingActivationMutation,
  csrfToken: string | null,
): Promise<ScheduleBindingActivationResult> {
  const body = ScheduleBindingActivationMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/schedule-bindings/${encodeURIComponent(bindingId)}/activations`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => ScheduleBindingActivationResultSchema.parse(payload),
  });
}

export async function createStageScenario(
  mutation: ScenarioMutation,
  csrfToken: string | null,
): Promise<ScenarioMutationResult> {
  const body = ScenarioMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/scenarios",
    method: "POST",
    csrfToken,
    body,
    parse: parseScenarioMutationResult,
  });
}

export async function updateStageScenario(
  scenarioId: string,
  mutation: ScenarioMutation,
  csrfToken: string | null,
): Promise<ScenarioMutationResult> {
  const body = ScenarioMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/scenarios/${encodeURIComponent(scenarioId)}`,
    method: "PUT",
    csrfToken,
    body,
    parse: parseScenarioMutationResult,
  });
}

export async function fetchKnowledgeSourceDetail(
  sourceId: string,
): Promise<KnowledgeSourceDetail> {
  const timer = withTimeout();
  try {
    const response = await fetch(`/api/knowledge-sources/${encodeURIComponent(sourceId)}`, {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return KnowledgeSourceDetailSchema.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError("Источник знаний не загрузился вовремя.", {
        code: "KNOWLEDGE_TIMEOUT",
      });
    }
    throw new ApiRequestError("Не удалось загрузить источник знаний с сервера.", {
      code: "KNOWLEDGE_UNAVAILABLE",
    });
  } finally {
    timer.dispose();
  }
}

export async function createKnowledgeSourcePublication(
  mutation: KnowledgeSourceMutation,
  csrfToken: string | null,
): Promise<KnowledgeSourceMutationResult> {
  const body = KnowledgeSourceMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/knowledge-sources",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => KnowledgeSourceMutationResultSchema.parse(payload),
  });
}

export async function createCompanyMediaAssetPublication(
  mutation: CompanyMediaAssetMutation,
  csrfToken: string | null,
): Promise<CompanyMediaAssetMutationResult> {
  const body = CompanyMediaAssetMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: "/api/company-media",
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => CompanyMediaAssetMutationResultSchema.parse(payload),
    timeoutMs: 60_000,
  });
}

export async function archiveCompanyMediaAssetPublication(
  mediaAssetId: string,
  mutation: CompanyMediaAssetArchiveMutation,
  csrfToken: string | null,
): Promise<{ mediaAssetId: string }> {
  const body = CompanyMediaAssetArchiveMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/company-media/${encodeURIComponent(mediaAssetId)}/archive`,
    method: "POST",
    csrfToken,
    body,
    parse: (payload) => CompanyMediaAssetArchiveResultSchema.parse(payload),
  });
}

export async function updateKnowledgeSourcePublication(
  sourceId: string,
  mutation: KnowledgeSourceMutation,
  csrfToken: string | null,
): Promise<KnowledgeSourceMutationResult> {
  const body = KnowledgeSourceMutationSchema.parse(mutation);
  return authenticatedJsonMutation({
    path: `/api/knowledge-sources/${encodeURIComponent(sourceId)}`,
    method: "PUT",
    csrfToken,
    body,
    parse: (payload) => KnowledgeSourceMutationResultSchema.parse(payload),
  });
}

export function describeApiError(error: unknown): string {
  if (error instanceof ApiRequestError) {
    const suffix = error.requestId ? ` Код обращения: ${error.requestId}.` : "";
    const translatedByCode: Record<string, string> = {
      SETUP_TOKEN_INVALID: "Одноразовый ключ установки недействителен или истёк.",
      SETUP_CLOSED: "Первичная настройка уже завершена.",
      AUTHENTICATION_FAILED: "Почта или пароль не подошли.",
      MFA_REQUIRED: "Нужно подтвердить действие кодом второго фактора.",
      MFA_INVALID: "Код второго фактора неверен или уже использован.",
      PROVIDER_VERIFICATION_FAILED: "Провайдер не подтвердил ключ или доступ к выбранной модели. Секрет не сохранён.",
      INTEGRATION_FORBIDDEN: "Подключения могут изменять только владелец и администратор.",
      CONNECTOR_NOT_FOUND: "Подключение недоступно для этой рабочей установки.",
      INTEGRATION_CONFLICT: "Подключение изменилось во время проверки. Обновите страницу перед повтором.",
      OAUTH_CALLBACK_INVALID: "Сессия авторизации amoCRM истекла или не совпала. Начните подключение заново.",
      FORBIDDEN: "У вашей роли нет права на это действие.",
      READINESS_BLOCKED: "Сначала устраните блокирующие проверки готовности.",
      CONFLICT: "Состояние уже изменилось. Обновите страницу и повторите.",
      NOT_FOUND: "Запрошенные данные больше недоступны. Начните действие заново.",
      UNAVAILABLE: "Сервис временно недоступен. Изменения не применены.",
      VALIDATION_FAILED: "Проверьте заполненные поля.",
    };
    const preserveServerMessage = new Set([
      "CSRF_TOKEN_UNAVAILABLE",
      "INVALID_WORKSPACE_RESPONSE",
      "INVALID_RESTORE_SAFETY_RESPONSE",
      "INVALID_TEAM_ACCESS_RESPONSE",
      "REQUEST_FAILED",
      "REQUEST_TIMEOUT",
      "WORKSPACE_TIMEOUT",
      "WORKSPACE_UNAVAILABLE",
      "TEAM_ACCESS_TIMEOUT",
      "TEAM_ACCESS_UNAVAILABLE",
      "RESTORE_SAFETY_TIMEOUT",
      "RESTORE_SAFETY_UNAVAILABLE",
      "RESTORE_RECONCILIATION_REQUIRED",
      "BOOTSTRAP_TIMEOUT",
      "BOOTSTRAP_UNAVAILABLE",
      "UNSUPPORTED_DATA_SOURCE",
      "STATE_REFRESH_REQUIRED",
      // Точная причина отказа повтора подготовки формулируется сервером: одна
      // общая фраза здесь снова спрятала бы девять разных причин.
      "RECOVERY_UNAVAILABLE",
      "RECOVERY_EVIDENCE_CHANGED",
    ]);
    if (error.code && preserveServerMessage.has(error.code)) {
      return `${error.message}${suffix}`;
    }
    if (error.code && translatedByCode[error.code]) {
      return `${translatedByCode[error.code]}${suffix}`;
    }
    if (error.status === 409) {
      return `Настройки изменились в другом окне. Обновите страницу и повторите.${suffix}`;
    }
    if (error.status === 422) {
      return `${error.message} Проверьте условия включения.${suffix}`;
    }
    if (error.status === 503) {
      return `Сервис временно не готов. Изменения не применены.${suffix}`;
    }
    if (error.status === 401) return `Проверьте введённые данные.${suffix}`;
    if (error.status === 403) return `Действие отклонено проверкой безопасности.${suffix}`;
    return `Сервер не подтвердил действие. Изменения не применены.${suffix}`;
  }
  return "Сервер не подтвердил действие. Изменения не применены.";
}

export function describePrivilegedApiError(error: unknown): string {
  if (error instanceof ApiRequestError) {
    const suffix = error.requestId ? ` Код обращения: ${error.requestId}.` : "";
    if (error.code === "AUTHENTICATION_FAILED") {
      return `Текущий пароль не подошёл. Подключение не изменено.${suffix}`;
    }
    if (error.code === "MFA_REQUIRED") {
      return `Введите код второго фактора или резервный код. Подключение не изменено.${suffix}`;
    }
    if (error.code === "MFA_INVALID") {
      return `Код второго фактора неверен или уже использован. Подключение не изменено.${suffix}`;
    }
  }
  return describeApiError(error);
}

export function describeTeamAccessApiError(error: unknown): string {
  if (error instanceof ApiRequestError) {
    const suffix = error.requestId ? ` Код обращения: ${error.requestId}.` : "";
    if (error.code === "AUTHENTICATION_FAILED") {
      return `Текущий пароль не подошёл. Доступы не изменены.${suffix}`;
    }
    if (error.code === "MFA_REQUIRED") {
      return `Для управления командой нужен настроенный второй фактор.${suffix}`;
    }
    if (error.code === "MFA_INVALID") {
      return `Код второго фактора неверен или уже использован. Доступы не изменены.${suffix}`;
    }
    if (error.code === "FORBIDDEN") {
      return `Ваша роль не разрешает это изменение состава команды.${suffix}`;
    }
    if (error.code === "CONFLICT") {
      return `Состав команды уже изменился или конфликтует с запросом. Перечитайте список.${suffix}`;
    }
  }
  return describeApiError(error);
}

export function describeTeamAccessCodeError(error: unknown): string {
  if (error instanceof ApiRequestError) {
    const suffix = error.requestId ? ` Код обращения: ${error.requestId}.` : "";
    if (error.code === "AUTHENTICATION_FAILED" || error.status === 401) {
      return `Одноразовый код недействителен, истёк, отозван или уже использован.${suffix}`;
    }
    if (error.code === "VALIDATION_FAILED" || error.status === 422) {
      return `Проверьте полный одноразовый код и новый пароль.${suffix}`;
    }
  }
  return describeApiError(error);
}

export function describeRestoreApiError(error: unknown): string {
  if (error instanceof ApiRequestError) {
    const suffix = error.requestId ? ` Код обращения: ${error.requestId}.` : "";
    if (error.code === "AUTHENTICATION_FAILED") {
      return `Текущий пароль не подошёл. Защитная блокировка сохранена.${suffix}`;
    }
    if (error.code === "MFA_REQUIRED") {
      return `Нужно подтвердить действие кодом второго фактора. Защитная блокировка сохранена.${suffix}`;
    }
    if (error.code === "MFA_INVALID") {
      return `Код второго фактора неверен или уже использован. Защитная блокировка сохранена.${suffix}`;
    }
    if (error.code === "FORBIDDEN") {
      return `Снять блокировку может только владелец или администратор. Защитная блокировка сохранена.${suffix}`;
    }
    if (error.code === "READINESS_BLOCKED") {
      return `Сервер обнаружил незавершённую проверку. Устраните причины ниже; защитная блокировка сохранена.${suffix}`;
    }
    if (error.code === "CONFLICT") {
      return `Операция восстановления изменилась или уже сверена. Перечитайте состояние сервера.${suffix}`;
    }
  }
  return describeApiError(error);
}

export async function fetchSetupStatus(): Promise<SetupStatus> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/setup/status", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return SetupStatusSchema.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    throw new ApiRequestError("Не удалось проверить состояние сервера.");
  } finally {
    timer.dispose();
  }
}

export async function fetchAuthenticationState(): Promise<AuthenticationState> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/auth/state", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    let payload: unknown;
    try {
      payload = await response.json();
    } catch {
      // The request reached the server, but the body could not be decoded as
      // JSON (for example, an HTML error page or a truncated response). This
      // is distinct from fetch itself being unable to reach the server.
      throw new ApiRequestError("Сервер вернул некорректный ответ о состоянии входа.", {
        code: "AUTH_STATE_INVALID_RESPONSE",
      });
    }
    const parsed = AuthenticationStateSchema.safeParse(payload);
    if (!parsed.success) {
      throw new ApiRequestError("Сервер вернул несовместимое состояние входа.", {
        code: "AUTH_STATE_INVALID_RESPONSE",
      });
    }
    return parsed.data;
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new ApiRequestError("Сервер не ответил вовремя при проверке входа.", {
        code: "AUTH_STATE_TIMEOUT",
      });
    }
    throw new ApiRequestError("Нет связи с сервером при проверке входа.", {
      code: "AUTH_STATE_NETWORK_FAILURE",
    });
  } finally {
    timer.dispose();
  }
}

export async function fetchSession(): Promise<SessionState | null> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/session", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: timer.signal,
    });
    if (response.status === 401) return null;
    if (!response.ok) throw await parseError(response);
    return SessionStateSchema.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    throw new ApiRequestError("Не удалось проверить вход в систему.");
  } finally {
    timer.dispose();
  }
}

async function publicAuthMutation(
  path: string,
  body: Login | SetupComplete,
): Promise<SessionState> {
  const timer = withTimeout();
  try {
    const response = await fetch(path, {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return SessionStateSchema.parse(await response.json());
  } catch (error) {
    if (error instanceof ApiRequestError) throw error;
    throw new ApiRequestError("Сервер не подтвердил вход. Попробуйте ещё раз.");
  } finally {
    timer.dispose();
  }
}

export async function completeSetup(input: SetupComplete): Promise<SessionState> {
  return publicAuthMutation("/api/setup/complete", SetupCompleteSchema.parse(input));
}

export async function login(input: Login): Promise<SessionState> {
  return publicAuthMutation("/api/session/login", LoginSchema.parse(input));
}

export async function logout(csrfToken: string): Promise<void> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/session", {
      method: "DELETE",
      credentials: "include",
      headers: { "x-csrf-token": csrfToken, "content-type": "application/json" },
      body: "{}",
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
  } finally {
    timer.dispose();
  }
}

export type MfaEnrollmentGrant = {
  secret: string;
  enrollmentUri: string;
  recoveryCodes: string[];
};

function parseMfaEnrollment(payload: unknown): MfaEnrollmentGrant {
  if (!payload || typeof payload !== "object") {
    throw new ApiRequestError("Сервер вернул неполные данные настройки второго фактора.");
  }
  const record = payload as Record<string, unknown>;
  if (
    typeof record.secret !== "string" ||
    typeof record.enrollmentUri !== "string" ||
    !Array.isArray(record.recoveryCodes) ||
    !record.recoveryCodes.every((code) => typeof code === "string")
  ) {
    throw new ApiRequestError("Сервер вернул неполные данные настройки второго фактора.");
  }
  return {
    secret: record.secret,
    enrollmentUri: record.enrollmentUri,
    recoveryCodes: record.recoveryCodes,
  };
}

export async function beginMfaEnrollment(
  currentPassword: string,
  csrfToken: string,
  currentMfaCode?: string,
): Promise<MfaEnrollmentGrant> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/security/mfa/enroll", {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({
        currentPassword,
        ...(currentMfaCode?.trim() ? { currentMfaCode: currentMfaCode.trim() } : {}),
      }),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
    return parseMfaEnrollment(await response.json());
  } finally {
    timer.dispose();
  }
}

export async function verifyMfaEnrollment(code: string, csrfToken: string): Promise<void> {
  const timer = withTimeout();
  try {
    const response = await fetch("/api/security/mfa/verify", {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({ code }),
      signal: timer.signal,
    });
    if (!response.ok) throw await parseError(response);
  } finally {
    timer.dispose();
  }
}

export async function fetchSemanticComparisons() {
  return authenticatedJsonQuery({ path: "/api/semantic-comparisons", parse: payload => SemanticComparisonSchema.array().parse(payload),
    timeoutMessage: "Не удалось загрузить сравнения.", timeoutCode: "SEMANTIC_TIMEOUT", failureMessage: "Не удалось загрузить сравнения.", failureCode: "SEMANTIC_FAILED" });
}
export async function createSemanticComparison(input: unknown, csrfToken: string | null) {
  return authenticatedJsonMutation({ path: "/api/semantic-comparisons", method: "POST", csrfToken,
    body: SemanticComparisonStartSchema.parse(input), parse: payload => SemanticComparisonSchema.parse(payload) });
}
export async function reviewSemanticComparison(id: string, input: unknown, csrfToken: string | null) {
  return authenticatedJsonMutation({ path: `/api/semantic-comparisons/${encodeURIComponent(id)}/reviews`, method: "POST", csrfToken,
    body: SemanticReviewSchema.parse(input), parse: () => undefined });
}

export async function fetchSemanticStagingStatus(): Promise<SemanticStagingStatus> {
  return authenticatedJsonQuery({ path: "/api/semantic-staging/status", parse: payload => SemanticStagingStatusSchema.parse(payload),
    timeoutMessage: "Не удалось проверить полигон.", timeoutCode: "STAGING_STATUS_TIMEOUT", failureMessage: "Не удалось проверить полигон.", failureCode: "STAGING_STATUS_FAILED" });
}

export async function fetchSandboxWorkflows(): Promise<SandboxWorkflow[]> {
  return authenticatedJsonQuery({path:"/api/semantic-staging/workflows",parse:payload=>SandboxWorkflowSchema.array().parse(payload),timeoutMessage:"Не удалось загрузить сценарии.",timeoutCode:"SANDBOX_TIMEOUT",failureMessage:"Не удалось загрузить сценарии.",failureCode:"SANDBOX_FAILED"});
}
export async function fetchSandboxAgents(): Promise<SandboxAgent[]> {
  return authenticatedJsonQuery({path:"/api/semantic-staging/agents",parse:payload=>SandboxAgentSchema.array().parse(payload),timeoutMessage:"Не удалось загрузить агентов.",timeoutCode:"SANDBOX_TIMEOUT",failureMessage:"Не удалось загрузить агентов.",failureCode:"SANDBOX_FAILED"});
}
export async function fetchSandboxDeals(): Promise<SandboxDeal[]> {
  return authenticatedJsonQuery({path:"/api/semantic-staging/deals",parse:payload=>SandboxDealSchema.array().parse(payload),timeoutMessage:"Не удалось загрузить сделки.",timeoutCode:"SANDBOX_TIMEOUT",failureMessage:"Не удалось загрузить сделки.",failureCode:"SANDBOX_FAILED"});
}
export async function createSandboxDeal(input:unknown,csrfToken:string|null):Promise<SandboxDeal> {
  return authenticatedJsonMutation({path:"/api/semantic-staging/deals",method:"POST",csrfToken,body:SandboxCreateSchema.parse(input),parse:payload=>SandboxDealSchema.parse(payload)});
}
export async function sendSandboxTurn(id:string,input:unknown,csrfToken:string|null):Promise<SandboxDeal> {
  return authenticatedJsonMutation({path:`/api/semantic-staging/deals/${encodeURIComponent(id)}/turns`,method:"POST",csrfToken,body:SandboxTurnInputSchema.parse(input),timeoutMs:330_000,parse:payload=>SandboxDealSchema.parse(payload)});
}

/** The deal card's bots: status per bot and the latest bot campaigns (15.10.2026). */
export async function fetchCrmDealBotDelivery(dealId: string): Promise<DealBotDelivery> {
  if (!UUID_PATTERN.test(dealId)) {
    throw new ApiRequestError("Некорректный идентификатор сделки.", { code: "CRM_DEAL_ID_INVALID" });
  }
  return authenticatedJsonQuery({
    path: `/api/deals/${encodeURIComponent(dealId)}/bot-delivery`,
    parse: (payload) => DealBotDeliverySchema.parse(payload),
    timeoutMessage: "Боты не ответили вовремя.",
    timeoutCode: "CRM_DEAL_BOTS_TIMEOUT",
    failureMessage: "Не удалось узнать статус в ботах.",
    failureCode: "CRM_DEAL_BOTS_UNAVAILABLE",
  });
}
